/**
 * Abtra Shop
 * Developer: Abdelhady "Hady" Salah
 * File: index.js
 * Description: Front-end application entrypoint
 * Last Updated: Feb 20 2024
 * 
 * 
 */

import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App.js';

import { HelmetProvider } from 'react-helmet-async';
import { AppContextProvider } from './components/context/AppContext.js';
import CartContextProvider from './components/context/CartContext.js';
import { SSRProvider } from 'react-bootstrap';

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import LoadingContextProvider from './components/context/LoadingContext.js';
import CustomerContextProvider from './components/context/CustomerContext.js';
import BreadcrumbContextProvider from './components/context/BreadcrumbContext.js';
import ToastContextProvider from './components/context/ToastContext.js';
import SocketContextProvider from './components/context/SocketContext.js';

// Hydrate root (for SSR - Server Side Rendering)
hydrateRoot(document.getElementById('root'), ( // eslint-disable-line no-undef
    <Router>
        <HelmetProvider>
            <AppContextProvider>
                <LoadingContextProvider>
                    <CartContextProvider>
                        <CustomerContextProvider>
                            <BreadcrumbContextProvider>
                                <ToastContextProvider>
                                    <SocketContextProvider>
                                        <SSRProvider>
                                            <App />
                                        </SSRProvider>
                                    </SocketContextProvider>                       
                                </ToastContextProvider>
                            </BreadcrumbContextProvider>
                        </CustomerContextProvider>
                    </CartContextProvider>
                </LoadingContextProvider>
            </AppContextProvider>
        </HelmetProvider>
    </Router>
));